import React from 'react';

const PanelScenarioCreateV1: React.FC = () => {
  return (
    <div className="overflow-hidden rounded-lg border border-[#263455] bg-[#0b1734]">
      <div className="flex items-center justify-between border-b border-[#2b3a61] px-4 py-3">
        <h2 className="text-base font-semibold text-white">Créer une intervention</h2>
      </div>
      <iframe
        title="Création intervention CTA"
        src="/panel/interventions/create?embed=1"
        className="h-[78vh] w-full border-0"
      />
    </div>
  );
};

export default PanelScenarioCreateV1;
